/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { AddEditStaticRouteComponent } from './AddEditStaticRoutesComponent/add-edit-static-route.component';
import { AuthGuard } from '../../../../../core/guards';
import { IpGroupsResolver, NetworkInterfaceResolver } from '../../../shared/resolvers';
import { LoadbalancerSharedModule } from '../../../shared/loadbalancer.shared.module';
import { NgModule } from '@angular/core';
import { StaticRoutesApiService } from '../../../shared/http';
import { StaticRoutesComponent } from './static-routes.component';
import { StaticRoutesService } from '../../../shared/services/components';

/**
 * Static routes.
 */
@NgModule({
    imports: [
        LoadbalancerSharedModule
    ],
    declarations: [
        AddEditStaticRouteComponent,
        StaticRoutesComponent
    ],
    providers: [
        AuthGuard,
        IpGroupsResolver,
        NetworkInterfaceResolver,
        StaticRoutesApiService,
        StaticRoutesService
    ]
})

export class StaticRoutesModule {
}
